import Form from "../../../../src/components/Form.tsx";
import * as React from 'react';
export default {
  Form,
  React
};